import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function OAuthCallback() {
  const location = useLocation();

  useEffect(() => {
    const qs = new URLSearchParams(location.search);
    const code = qs.get("code");
    const state = qs.get("state");

    if (code && state && window.opener) {
      window.opener.postMessage(
        { type: "oauth-code", payload: { code, state } },
        window.location.origin
      );
    } else if (window.opener) {
      window.opener.postMessage(
        { type: "oauth-error", error: "missing_code_or_state" },
        window.location.origin
      );
    }
    window.close();
  }, [location.search]);

  return null;
}
